import { render, staticRenderFns } from "./ModalEditarProtocoloDefault.vue?vue&type=template&id=68008c7e&lang=pug"
import script from "./ModalEditarProtocoloDefault.vue?vue&type=script&lang=js"
export * from "./ModalEditarProtocoloDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports